module.exports = __webpack_public_path__ + "static/media/favicon-m.1af96880.ico";